import * as React from 'react'
import { useTranslation } from 'hooks'
import * as S from './ConsignmentRetrieval.styles'

export interface Provider {
  key: string
  name: string
  fee: string
  feeCents: number
}

export const PROVIDERS: Provider[] = [
  { key: 'stockx', name: 'StockX', fee: '\u00a33.50', feeCents: 350 },
  { key: 'goat', name: 'GOAT', fee: '\u00a33.50', feeCents: 350 },
  { key: 'poizon', name: 'Poizon', fee: '\u00a33.50', feeCents: 350 },
  { key: 'whatnot', name: 'WhatNot', fee: '\u00a33.50', feeCents: 350 },
  { key: 'own_label', name: 'Own Label', fee: '\u00a35.00', feeCents: 500 }
]

interface ProviderStepProps {
  selected: string | null
  onSelect: (provider: Provider) => void
}

const ProviderStep: React.FC<ProviderStepProps> = ({ selected, onSelect }) => {
  const { t } = useTranslation()

  return (
    <>
      <S.DropZoneHint style={{ marginBottom: 12, marginTop: 0 }}>
        {t('views.account.consignment_retrieval.provider_hint')}
      </S.DropZoneHint>
      <S.ProviderList>
        {PROVIDERS.map((provider) => (
          <S.ProviderCard
            key={provider.key}
            selected={selected === provider.key}
            htmlFor={`provider-${provider.key}`}
          >
            <S.ProviderLeft>
              <S.ProviderRadio
                type="radio"
                id={`provider-${provider.key}`}
                name="provider"
                checked={selected === provider.key}
                onChange={() => onSelect(provider)}
              />
              <S.RadioDot checked={selected === provider.key} />
              <S.ProviderName>{provider.name}</S.ProviderName>
            </S.ProviderLeft>
            <S.ProviderFee>{provider.fee}</S.ProviderFee>
          </S.ProviderCard>
        ))}
      </S.ProviderList>
    </>
  )
}

export default ProviderStep
